import { useMemo } from 'react';
import { Navigate, useLocation, useSearchParams } from 'react-router';

function LegacyRedirect() {
    const [searchParams] = useSearchParams();
    const location = useLocation();
    const propertyAssociationId = searchParams.get('propertyAssociationId');
    const navigationState = useMemo(() => ({ pathname: location.pathname, search: searchParams.toString() }), [location.pathname, searchParams]);

    if (propertyAssociationId) {
        return <Navigate to={`/${propertyAssociationId}`} replace state={navigationState} />;
    }

    return <Navigate to='/' replace state={navigationState} />;
}

export default LegacyRedirect;
